import { DELETE_ITEM_MBQ_MOQ, DELETE_ITEM_MBQ_MOQ_SUCCESS, GET_ITEM_MBQ_MOQ, GET_ITEM_MBQ_MOQ_SUCCESS, ITEM_MBQ_MOQ_ERROR, RESET_ITEM_MBQ_MOQ_STATE, SAVE_ITEM_MBQ_MOQ, SAVE_ITEM_MBQ_MOQ_SUCCESS } from "./actionType";


const INIT_STATE = {
    tableData: [],
    PostData: { Status: false },
    deleteData: { Status: false },

    goBtnLoading: false,
    saveBtnloading: false,
    listBtnLoading: false,
};

const ItemMBQMOQReducer = (state = INIT_STATE, action) => {
    switch (action.type) {

        // 🔹 GET
        case GET_ITEM_MBQ_MOQ:
            return {
                ...state,
                goBtnLoading: true,
            };

        case GET_ITEM_MBQ_MOQ_SUCCESS:
            return {
                ...state,
                tableData: action.payload,
                goBtnLoading: false,
            };

        // 🔹 SAVE
        case SAVE_ITEM_MBQ_MOQ:
            return {
              ...state,
              saveBtnloading: true,
              PostData: { Status: false }   //  reset old message
            };

        case SAVE_ITEM_MBQ_MOQ_SUCCESS:
            return {
                ...state,
                PostData: action.payload,
                saveBtnloading: false,
            };

        // 🔹 DELETE
        case DELETE_ITEM_MBQ_MOQ:
            return {
                ...state,
                listBtnLoading: action.config?.btnId,
            };

        case DELETE_ITEM_MBQ_MOQ_SUCCESS:
            return {
                ...state,
                deleteData: action.payload,
                listBtnLoading: false,
            };

        // 🔹 ERROR
        case ITEM_MBQ_MOQ_ERROR:
            return {
                ...state,
                saveBtnloading: false,
                listBtnLoading: false,
                goBtnLoading: false,
            };
       

        // 🔹 RESET
        case RESET_ITEM_MBQ_MOQ_STATE:
            return {
                ...state,
        
                tableData: [],
        
                PostData: { Status: false },
        
                deleteData: { Status: false },
        
                goBtnLoading: false,
        
                saveBtnloading: false,

                listBtnLoading: false,
            
            };

        default:
            return state;
    }
};

export default ItemMBQMOQReducer;